
export const isClientInvoiceFinal = status => 
  status === 'ClientInvoiceStatus.FINAL' ||
  status === 'FINAL'
  
export const isClientInvoiceCancelled = status => 
  status === 'ClientInvoiceStatus.CANCELLED' ||
  status === 'CANCELLED'
